import { useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import ROUTE_NAME from '../../../routes/RouteName';
// import TermLoanModal from './components/TermLoanModal';
import CurrentList from './CurrentList';
import HistoryList from './HistoryList';
// import { useCommentModalContext } from '../../../contexts/CommentModalContext';
import classnames from 'classnames';
import { useDict } from '../../../contexts/LanguageContext';

const ListNote = (props) => {
    const {
        investmentNotes,
        pageCount,
        page,
        setPage,
        isFetching,
        setAllocatedCompleted,
        onDownloadInvestmentMemo,
        isTermLoanModalOpen,
        onOpenTermLoanModal,
        onCloseTermLoanModal,
        newInvoiceDetails,
    } = props;

    const [activeTab, setActiveTab] = useState('1');
    const dict = useDict();

    const { openCommentModal } = false;

    return (
        <div>
            {/* <TermLoanModal
                isOpenModal={isTermLoanModalOpen}
                modalToggle={onCloseTermLoanModal}
                title="Repayments"
                invoiceDetails={newInvoiceDetails}
            /> */}

            <div className="tabs tabs--bordered-bottom mb-3">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({
                                active: activeTab === '1',
                            })}
                            onClick={() => {
                                setActiveTab('1');
                                setAllocatedCompleted('allocated');
                            }}
                        >
                            <span
                                style={{ fontWeight: 'bold', color: '#264391' }}
                            >
                                {dict.current}
                            </span>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({
                                active: activeTab === '2',
                            })}
                            onClick={() => {
                                setActiveTab('2');
                                setAllocatedCompleted('completed');
                            }}
                        >
                            <span
                                style={{ fontWeight: 'bold', color: '#264391' }}
                            >
                                {dict.completed}
                            </span>
                        </NavLink>
                    </NavItem>
                </Nav>
            </div>

            <TabContent
                className="d-flex flex-grow-1 flex-column"
                activeTab={activeTab}
            >
                {activeTab === '1' && (
                    <TabPane
                        className="d-flex flex-grow-1 flex-column"
                        tabId="1"
                    >
                        <CurrentList
                            investmentNotes={investmentNotes}
                            pageCount={pageCount}
                            page={page}
                            setPage={setPage}
                            isFetching={isFetching}
                            doTermLoanModal={onOpenTermLoanModal}
                            onShowComment={(data) =>
                                openCommentModal({
                                    commentData: data.comments,
                                })
                            }
                        />
                    </TabPane>
                )}
                {activeTab === '2' && (
                    <TabPane
                        className="d-flex flex-grow-1 flex-column"
                        tabId="2"
                    >
                        <HistoryList
                            investmentNotes={investmentNotes}
                            pageCount={pageCount}
                            page={page}
                            setPage={setPage}
                            isFetching={isFetching}
                            doTermLoanModal={onOpenTermLoanModal}
                            onShowComment={(data) =>
                                openCommentModal({
                                    commentData: data.comments,
                                })
                            }
                        />
                    </TabPane>
                )}
            </TabContent>
        </div>
    );
};

export default ListNote;
